import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconUnarchive.tsx
const OutlinedFilledUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.5-576 323-418l52 54 65-65v150h80v-150l65 64 53-54-157.5-157ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z" })
});
const OutlinedUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.5-576 323-419l52 54 65-64v150h80v-150l65 65 53-54-157.5-158ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z" })
});
const RoundedFilledUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.37-278q16.63 0 28.13-11.76T520-318v-125l46 46q11.09 11 26.04 10.5Q607-387 619-399.36q11-11.35 10.5-26.36T618-452L514-558q-14.36-13-33.68-13T447-557L342-451q-11 11.09-11.5 26.54-.5 15.46 12.36 27.96 9.85 10.5 24.86 10.5T394-397l46-46v125q0 16.48 11.87 28.24Q463.74-278 480.37-278ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z" })
});
const RoundedUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.37-278q16.63 0 28.13-11.76T520-318v-125l46 46q11.09 11 26.04 10.5Q607-387 619-399.36q11-11.35 10.5-26.36T618-452L514-558q-14.45-13-33.73-13Q461-571 447-557L342-451q-11 11.09-11.5 26.54-.5 15.46 12.36 27.96 9.54 10.5 24.71 10.5 15.16 0 26.43-11l46-46v125q0 16.48 11.87 28.24Q463.74-278 480.37-278ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z" })
});
const SharpFilledUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-576 323-418l52 54 65-65v150h80v-150l65 64 53-54-158-157ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Z" })
});
const SharpUnarchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-576 323-419l52 54 65-64v150h80v-150l65 65 53-54-158-158Zm-291-63v450h582v-450H189ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Zm257 312Z" })
});
const componentMap = {
	outlined: OutlinedUnarchive,
	"outlined-fill": OutlinedFilledUnarchive,
	rounded: RoundedUnarchive,
	"rounded-fill": RoundedFilledUnarchive,
	sharp: SharpUnarchive,
	"sharp-fill": SharpFilledUnarchive
};
const IconUnarchive = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconUnarchive };